import React from 'react'

import { SpaceProps } from '../../../themes'
import { Container } from './styles'

export interface FieldContentProps extends SpaceProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Field children
   */
  children: React.ReactNode
}

export const FieldContent = ({
  className,
  children,
  ...spaceProps
}: FieldContentProps) => {
  return (
    <Container className={className} {...spaceProps}>
      {children}
    </Container>
  )
}
